const FilterArrow = ({ width = 18, height = 18, color = '#000000', isOpen = false }) => {
  return (
    <>
      {isOpen ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none">
          <path d="M-8.42937e-08 8L0 10L7 10L8 9L7 8L-8.42937e-08 8Z" fill={color} />
          <path d="M18 8L18 10L11 10L10 9L11 8L18 8Z" fill={color} />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none">
          <path d="M-8.42937e-08 8L0 10L7 10L8 9L7 8L-8.42937e-08 8Z" fill={color} />
          <path d="M8 18L10 18L10 11L9 10L8 11L8 18Z" fill={color} />
          <path d="M18 8L18 10L11 10L10 9L11 8L18 8Z" fill={color} />
          <path d="M10 3.49691e-07L8 0L8 7L9 8L10 7L10 3.49691e-07Z" fill={color} />
        </svg>
      )}
    </>
  )
}

export default FilterArrow
